/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OrderAPI {

  /**
   * Method that returns a list of orders
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param statusId
   * @param agencyId
   * @param name
   * @param id
   * @param representativeId
   * @param budget
   * @param maxImpressions
   * @param advertiserId
   * @param startDate
   * @param endDate
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiOrderList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    statusId?: 'active' | 'cancelled' | 'expired' | 'pending' | 'planning' | 'pricing' | 'reservation' | 'review' | 'temporary',
    agencyId?: number | null,
    name?: string | null,
    id?: Array<number>,
    representativeId?: number,
    budget?: number | null,
    maxImpressions?: number | null,
    advertiserId?: number | null,
    startDate?: string | null,
    endDate?: string | null,
  ): CancelablePromise<Array<{
    id: number;
    agency_id: number | null;
    user_id: number;
    representative_id: number;
    advertiser_id: number | null;
    platform_id: number;
    label: string | null;
    internal_reference_number: string | null;
    name: string | null;
    delivery_fee_active: boolean;
    instructions: string | null;
    notes: string | null;
    created_at: string | null;
    updated_at: string | null;
    start_date: string | null;
    end_date: string | null;
    budget: number | null;
    budget_currency_id: string;
    is_paused: boolean;
    max_impressions: number | null;
    views?: number;
    cad_total_spend?: number;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/order/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'status_id': statusId,
        'agency_id': agencyId,
        'name': name,
        'id': id,
        'representative_id': representativeId,
        'budget': budget,
        'max_impressions': maxImpressions,
        'advertiser_id': advertiserId,
        'start_date': startDate,
        'end_date': endDate,
      },
    });
  }

  /**
   * Method that returns a list of orders
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param statusId
   * @param agencyId
   * @param name
   * @param id
   * @param representativeId
   * @param budget
   * @param maxImpressions
   * @param advertiserId
   * @param startDate
   * @param endDate
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiOrderCount(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    statusId?: 'active' | 'cancelled' | 'expired' | 'pending' | 'planning' | 'pricing' | 'reservation' | 'review' | 'temporary',
    agencyId?: number | null,
    name?: string | null,
    id?: Array<number>,
    representativeId?: number,
    budget?: number | null,
    maxImpressions?: number | null,
    advertiserId?: number | null,
    startDate?: string | null,
    endDate?: string | null,
  ): CancelablePromise<{
    count: number;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/order/count',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'status_id': statusId,
        'agency_id': agencyId,
        'name': name,
        'id': id,
        'representative_id': representativeId,
        'budget': budget,
        'max_impressions': maxImpressions,
        'advertiser_id': advertiserId,
        'start_date': startDate,
        'end_date': endDate,
      },
    });
  }

  /**
   * Method that returns a particular order
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiOrder(
    id: number,
  ): CancelablePromise<{
    id: number;
    agency_id: number | null;
    user_id: number;
    representative_id: number;
    advertiser_id: number | null;
    platform_id: number;
    label: string | null;
    internal_reference_number: string | null;
    name: string | null;
    delivery_fee_active: boolean;
    instructions: string | null;
    notes: string | null;
    created_at: string | null;
    updated_at: string | null;
    start_date: string | null;
    end_date: string | null;
    budget: number | null;
    budget_currency_id: string;
    is_paused: boolean;
    max_impressions: number | null;
  } | null> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/order/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that creates an order
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiOrder(
    requestBody: {
      id?: number;
      agency_id?: number | null;
      user_id: number;
      representative_id?: number;
      advertiser_id?: number | null;
      platform_id?: number;
      label?: string | null;
      internal_reference_number?: string | null;
      name?: string | null;
      delivery_fee_active?: boolean;
      instructions?: string | null;
      notes?: string | null;
      created_at?: string | null;
      updated_at?: string | null;
      start_date?: string | null;
      end_date?: string | null;
      budget?: number | null;
      budget_currency_id?: string;
      is_paused?: boolean;
      max_impressions?: number | null;
    },
  ): CancelablePromise<{
    id: number;
    agency_id: number | null;
    user_id: number;
    representative_id: number;
    advertiser_id: number | null;
    platform_id: number;
    label: string | null;
    internal_reference_number: string | null;
    name: string | null;
    delivery_fee_active: boolean;
    instructions: string | null;
    notes: string | null;
    created_at: string | null;
    updated_at: string | null;
    start_date: string | null;
    end_date: string | null;
    budget: number | null;
    budget_currency_id: string;
    is_paused: boolean;
    max_impressions: number | null;
    views?: number;
    cad_total_spend?: number;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/order',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates an order
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiOrder(
    requestBody: {
      id: number;
      agency_id?: number | null;
      user_id?: number;
      representative_id?: number;
      advertiser_id?: number | null;
      platform_id?: number;
      label?: string | null;
      internal_reference_number?: string | null;
      name?: string | null;
      delivery_fee_active?: boolean;
      instructions?: string | null;
      notes?: string | null;
      created_at?: string | null;
      updated_at?: string | null;
      start_date?: string | null;
      end_date?: string | null;
      budget?: number | null;
      budget_currency_id?: string;
      is_paused?: boolean;
      max_impressions?: number | null;
    },
  ): CancelablePromise<{
    id: number;
    agency_id: number | null;
    user_id: number;
    representative_id: number;
    advertiser_id: number | null;
    platform_id: number;
    label: string | null;
    internal_reference_number: string | null;
    name: string | null;
    delivery_fee_active: boolean;
    instructions: string | null;
    notes: string | null;
    created_at: string | null;
    updated_at: string | null;
    start_date: string | null;
    end_date: string | null;
    budget: number | null;
    budget_currency_id: string;
    is_paused: boolean;
    max_impressions: number | null;
    views?: number;
    cad_total_spend?: number;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/order',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
